import { render, staticRenderFns } from "./drawio_toolbar_button.vue?vue&type=template&id=c0ef18d4&vue3"
import script from "./drawio_toolbar_button.vue?vue&type=script&lang=js&vue3"
export * from "./drawio_toolbar_button.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports